<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table class="sa-b-table sa-card-border" sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light">
                        <template #cell(index)="row">
                            <span>{{ row.index + 1 }} </span>
                        </template>

                        <template #cell(stato)="row">
                            <b-badge pill :variant="statoDb(row.item.stato)">
                                {{ row.item.stato }}
                            </b-badge>
                        </template>
                    </b-table>
                </div>

                <db-compare-modal-edit-component ref="cmpDbCompareModalEdit"></db-compare-modal-edit-component>
            </div>
        </div>
    </div>
</template>

<script>
import dbCompareModalEditComponent from "./dbCompareModalEditComponent.vue";
export default {
    components: { dbCompareModalEditComponent },

    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "DB Struttura",
                    key: "dbStruttura",
                },
                {
                    label: "DB HL7",
                    key: "dbHl7",
                },
                {
                    label: "DB THCS",
                    key: "dbThcs",
                },
                {
                    label: "Stato",
                    key: "stato",
                },
            ],
        };
    },

    methods: {
        nuovoDbCompare() {
            let me = this;
            me.$refs.cmpDbCompareModalEdit.show({
                dbStruttura: null,
                dbHl7: null,
                dbThcs: null,
                stato: null,
            });
        },

        loadData() {
            let me = this;
            me.items = [
                { dbStruttura: "1829", dbHl7: "1829", dbThcs: "1829", stato: "" },
                { dbStruttura: "", dbHl7: "1830", dbThcs: "1830", stato: "" },
                { dbStruttura: "1831", dbHl7: "", dbThcs: "1831", stato: "" },
                { dbStruttura: "1832", dbHl7: "1832", dbThcs: "", stato: "" },
                { dbStruttura: "", dbHl7: "", dbThcs: "", stato: "" },
            ];

            me.items.forEach((item) => {
                item.stato = me.calcolaStato(item);
            });
            me.rows = me.items.length;
            me.listKey += 1;
        },

        calcolaStato(item) {
            const strutturaMancante = !item.dbStruttura;
            const hl7Mancante = !item.dbHl7;
            const thcsMancante = !item.dbThcs;

            if (strutturaMancante && hl7Mancante && thcsMancante) {
                return "Tutti i DB Mancanti";
            } else if (strutturaMancante) {
                return "DB Struttura Mancante";
            } else if (hl7Mancante) {
                return "DB HL7 Mancante";
            } else if (thcsMancante) {
                return "DB THCS Mancante";
            } else if (item.dbStruttura === item.dbHl7 && item.dbHl7 === item.dbThcs) {
                return "ALLINEATO";
            }
        },

        statoDb(status) {
            switch (status) {
                case "ALLINEATO":
                    return "success";
                case "DB Struttura Mancante":
                    return "danger";
                case "DB HL7 Mancante":
                    return "danger";
                case "DB THCS Mancante":
                    return "danger";
                case "Tutti i DB Mancanti":
                    return "danger";
                default:
                    return "secondary";
            }
        },
    },
};
</script>

<style></style>
